import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Lightning, List, X, Crown, SignOut, GearSix } from "@phosphor-icons/react";

const links = [
  { to: "/marketplace", label: "Marketplace" },
  { to: "/bundles", label: "Bundles" },
  { to: "/comedy", label: "Comedy" },
  { to: "/premium", label: "Premium" },
];

export default function Navbar() {
  const { user, login, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 glass border-b border-white/10" style={{ background: "rgba(5,5,10,0.7)" }}>
      <nav className="max-w-[1400px] mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="w-9 h-9 bg-[#FFEB3B] flex items-center justify-center rounded-sm group-hover:shadow-[0_0_18px_rgba(255,235,59,0.6)] transition-shadow">
            <Lightning weight="fill" size={22} className="text-[#05050A]" />
          </div>
          <span className="font-display font-black text-lg tracking-tighter leading-none">
            D&J<span className="text-[#00E5FF]">.</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors hover:text-[#00E5FF] ${
                location.pathname === l.to ? "text-[#00E5FF]" : "text-white/70"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          {user?.is_admin && (
            <button data-testid="nav-admin-btn" onClick={() => navigate("/admin")}
              className="flex items-center gap-2 text-sm text-white/70 hover:text-[#FF00AA] transition-colors">
              <GearSix size={18} /> Admin
            </button>
          )}
          {user ? (
            <div className="flex items-center gap-3">
              {user.is_premium && (
                <span className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-[#FFEB3B] text-glow-yellow">
                  <Crown weight="fill" size={16} /> Premium
                </span>
              )}
              <button data-testid="nav-account" onClick={() => navigate("/account")} className="flex items-center gap-2">
                <img src={user.picture || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || "U")}&background=00E5FF&color=05050A`}
                  alt="" className="w-8 h-8 rounded-full border border-white/20" />
              </button>
              <button data-testid="nav-logout" onClick={logout} className="text-white/50 hover:text-white transition-colors">
                <SignOut size={20} />
              </button>
            </div>
          ) : (
            <button data-testid="nav-login-btn" onClick={login}
              className="bg-[#FFEB3B] text-[#05050A] font-bold text-sm px-5 py-2.5 rounded-sm hover:bg-[#fff35c] hover:shadow-[0_0_20px_rgba(255,235,59,0.5)] transition-all">
              Sign In
            </button>
          )}
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-white/10 px-5 py-6 flex flex-col gap-4 bg-[#05050A]">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-white/80 text-lg font-medium">
              {l.label}
            </Link>
          ))}
          {user?.is_admin && <Link to="/admin" onClick={() => setOpen(false)} className="text-[#FF00AA] text-lg">Admin</Link>}
          {user ? (
            <button onClick={logout} className="text-left text-white/60 text-lg">Sign Out</button>
          ) : (
            <button onClick={login} className="bg-[#FFEB3B] text-[#05050A] font-bold px-5 py-3 rounded-sm">Sign In</button>
          )}
        </div>
      )}
    </header>
  );
}
